export const CLEAR_PROCESS_STATEMENTS = 'CLEAR_PROCESS_STATEMENTS';

export const clearProcessStatements = () => ({
    type: CLEAR_PROCESS_STATEMENTS,
});
